// useConfig() → UseQueryResult<AppConfig>     key ["config"], staleTime Infinity
// Public feature flags from GET /v1/config: GitHub sign-in (enabled/required/login URL) and
// Cloudflare Turnstile (enabled/sitekey). Read once per page load. A backend without the
// endpoint reports everything off (DEFAULT_CONFIG); while loading, `data` is undefined.
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { keys } from "./keys";

export function useConfig() {
  return useQuery({
    queryKey: keys.config,
    queryFn: () => api.config(),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 2,
  });
}
